module.exports = __webpack_public_path__ + "img/home.2a02f561.png";